const BLUE = "#4285f4";
const RED = "#ea4335";
const YELLOW = "#fbbc04";
const GREEN = "#34a853";
const PINK = "#f538a0";

const DARK_BLUE = "#174ea6";
const DARK_RED = "#a50e0e";
const DARK_YELLOW = "#e37400";
const DARK_GREEN = "#0d652d";
const DARK_PINK = "#9c166b";

const LIGHT_GREY = "#f1f3f4";
const DARK_GREY = "#3c4043";
const GREY = "#9aa0a6";

const BLACK = "#000000";
const WHITE = "#ffffff";


export {
  BLUE,
  RED,
  YELLOW,
  GREEN,
  PINK,
  DARK_BLUE,
  DARK_RED,
  DARK_YELLOW,
  DARK_GREEN,
  DARK_PINK,
  LIGHT_GREY,
  DARK_GREY,
  GREY,
  BLACK,
  WHITE
};
